import { ApiResponse } from 'interfaces/api-response';
import { IGetAllWorkCalendarResponse } from 'interfaces/work-calendar';
import { getBaseHeaderApi } from '../services/apiHelper';
import { adminApi } from '../services/services';

export const adminWorkCalendarApi = adminApi.enhanceEndpoints({ addTagTypes: ['workCalendars', 'workCalendarDetail'] }).injectEndpoints({
    endpoints(builder) {
        return {
            getAllWorkCalendarApi: builder.query<
                ApiResponse<IGetAllWorkCalendarResponse[]>,
                {
                    fromDate: string;
                    toDate: string;
                }
            >({
                query: ({ fromDate, toDate }) => ({
                    url: `/company-holiday?fromDate=${fromDate}&toDate=${toDate}`,
                    method: 'GET',
                    headers: getBaseHeaderApi()
                }),
                providesTags: ['workCalendars']
            }),
            getWorkCalendarByIdApi: builder.query<ApiResponse<IGetAllWorkCalendarResponse>, { id: string }>({
                query: ({ id }) => ({
                    url: `/company-holiday/${id}`,
                    method: 'GET',
                    headers: getBaseHeaderApi()
                }),
                providesTags: ['workCalendarDetail']
            }),
            updateWorkCalendarApi: builder.mutation<
                ApiResponse<IGetAllWorkCalendarResponse>,
                {
                    id: string;
                    title: string;
                    date: string;
                }
            >({
                query: ({ id, title, date }) => ({
                    url: `/company-holiday/${id}`,
                    method: 'PATCH',
                    data: { title, date },
                    headers: getBaseHeaderApi()
                }),
                invalidatesTags: ['workCalendarDetail', 'workCalendars']
            }),
            deleteWorkCalendarApi: builder.mutation<ApiResponse<IGetAllWorkCalendarResponse>, { id: string }>({
                query: ({ id }) => ({
                    url: `/company-holiday/${id}`,
                    method: 'DELETE',
                    headers: getBaseHeaderApi()
                }),
                invalidatesTags: ['workCalendars']
            }),
            createWorkCalendarApi: builder.mutation<ApiResponse<IGetAllWorkCalendarResponse>, { title: string; date: string }>({
                query: (body) => ({
                    url: '/company-holiday',
                    method: 'POST',
                    data: body,
                    headers: getBaseHeaderApi()
                }),
                invalidatesTags: ['workCalendars']
            }),
            createCurrentYearHolidayApi: builder.mutation<ApiResponse<null>, null>({
                query: () => ({
                    url: `/company-holiday/generate`,
                    method: 'POST',
                    headers: getBaseHeaderApi()
                }),
                invalidatesTags: ['workCalendars']
            })
        };
    }
});

export const {
    useGetAllWorkCalendarApiQuery,
    useCreateWorkCalendarApiMutation,
    useGetWorkCalendarByIdApiQuery,
    useUpdateWorkCalendarApiMutation,
    useDeleteWorkCalendarApiMutation,
    useCreateCurrentYearHolidayApiMutation
} = adminWorkCalendarApi;
